import compareSettings from '~/settings/compareSettings';
export const getExactMatchKey = (anchorTags, classification) => {
    return anchorTags.has(classification.name)
        ? { rowKey: classification.name, tabKey: classification.name }
        : undefined;
};
export const getMatchingParentKey = (anchorTags, classification) => {
    var _a;
    if (!((_a = classification.parents) === null || _a === void 0 ? void 0 : _a.length))
        return;
    const parentsInAnchorDoc = classification.parents.filter(parentClassification => {
        return anchorTags.get(parentClassification.name);
    });
    if (parentsInAnchorDoc.length) {
        return { rowKey: parentsInAnchorDoc[0].name, tabKey: classification.name };
    }
};
export const getMatchingChildKeys = (anchorTags, classification) => {
    var _a;
    if (!((_a = classification.children) === null || _a === void 0 ? void 0 : _a.length))
        return;
    const childrenInAnchorDoc = classification.children.filter(childClassification => {
        return anchorTags.get(childClassification.name);
    });
    if (childrenInAnchorDoc.length) {
        return childrenInAnchorDoc.map(child => {
            return { rowKey: child.name, tabKey: classification.name };
        });
    }
};
export const getExactMatchDescriptorInCategoryFamily = (anchorTags, classification) => {
    const matchingCategoryFamily = compareSettings.categoryFamilies.find(categoryFamily => {
        return categoryFamily.find(category => category === classification.category);
    });
    if (!matchingCategoryFamily)
        return;
    const matchingKeys = [];
    for (const category of matchingCategoryFamily) {
        if (anchorTags.has(`${category}: ${classification.descriptor}`)) {
            matchingKeys.push({
                rowKey: `${category}: ${classification.descriptor}`,
                tabKey: `${category}: ${classification.descriptor}`,
            });
        }
    }
    return matchingKeys;
};
export const getDescriptorParentInCategoryFamily = (anchorTags, classification) => {
    var _a, _b;
    if (!((_a = classification.parents) === null || _a === void 0 ? void 0 : _a.length))
        return;
    const matchingCategoryFamily = compareSettings.categoryFamilies.find(categoryFamily => {
        return categoryFamily.find(category => category === classification.category);
    });
    if (!matchingCategoryFamily)
        return;
    const parentDescriptor = (_b = classification.parents[0].name.split(':')[1]) === null || _b === void 0 ? void 0 : _b.trim();
    const matchingKeys = [];
    for (const category of matchingCategoryFamily) {
        if (anchorTags.has(`${category}: ${parentDescriptor}`)) {
            matchingKeys.push({
                rowKey: `${category}: ${parentDescriptor}`,
                tabKey: `${category}: ${classification.descriptor}`,
            });
        }
    }
    return matchingKeys;
};
export const getDescriptorChildrenInCategoryFamily = (anchorTags, classification) => {
    var _a, _b;
    if (!((_a = classification.children) === null || _a === void 0 ? void 0 : _a.length))
        return;
    const matchingCategoryFamily = compareSettings.categoryFamilies.find(categoryFamily => {
        return categoryFamily.find(category => category === classification.category);
    });
    if (!matchingCategoryFamily)
        return;
    const matchingKeys = [];
    for (const category of matchingCategoryFamily) {
        for (const childClassification of classification.children) {
            const childDescriptor = (_b = childClassification.name.split(':')[1]) === null || _b === void 0 ? void 0 : _b.trim();
            if (anchorTags.has(`${category}: ${childDescriptor}`)) {
                matchingKeys.push({
                    rowKey: `${category}: ${childDescriptor}`,
                    tabKey: `${category}: ${classification.descriptor}`,
                });
            }
        }
    }
    return matchingKeys;
};
